export App from './App';
export ForgotPassword from './ForgotPassword';
export SetNewPassword from './SetNewPassword';
export Signup from './Signup';

// User
export UserNav from './User/UserNav';
export Cart from './User/Cart/Cart';
export Contact from './User/Contact/Contact';
export Home from './User/Home/Home';
export HomeProducts from './User/Home/Products';
export Payment from './User/Payment/Payment';
export PriceTable from './User/PriceTable/PriceTable';
export Products from './User/Product/Products';
export ProductDetail from './User/Product/ProductDetail';
export Info from './User/Profile/Info';
export History from './User/Profile/History';
export Profile from './User/Profile/Profile';
export Wishlist from './User/Wishlist/Wishlist';

// Admin
export AdminNav from './Admin/AdminNav';
export AdminCompanies from './Admin/AdminCompany/AdminCompanies';

export AdminCustomers from './Admin/AdminCustomer/AdminCustomers';
export AdminCustomer from './Admin/AdminCustomer/AdminCustomer';

export AdminGiveaways from './Admin/AdminGiveaway/AdminGiveaways';

export AdminOrders from './Admin/AdminOrder/AdminOrders';
export AdminPayment from './Admin/AdminPayment/AdminPayment';
export AdminProducts from './Admin/AdminProduct/AdminProducts';
export AdminProduct from './Admin/AdminProduct/AdminProduct';
export AdminPromocodes from './Admin/AdminPromocode/AdminPromocodes';
export AdminPromocode from './Admin/AdminPromocode/AdminPromocode';
export AdminRewards from './Admin/AdminReward/AdminRewards';
export AdminReward from './Admin/AdminReward/AdminReward';
export AdminSetting from './Admin/AdminSetting/AdminSetting';



/** WEBPACK FOOTER **
 ** ./src/containers/index.js
 **/